/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One calendar-day bucket (in the requested timezone) for the
 * "Emails sent, replies & interest by day" chart.
 */
export interface JobSequenceAnalyticsDay {
  date: string;
  /** @minimum 0 */
  sent: number;
  /** @minimum 0 */
  replies: number;
  /** @minimum 0 */
  interested: number;
}
